import { Component } from '@angular/core';
import { SidebarService } from '../../core/services/sidebar.service';

/** Reuses Empower's header and menu; child navigation preserves this layout. */
@Component({
  selector: 'app-workforce-host',
  template: `
    <app-header-global></app-header-global>
    <div class="workforce-host-layout" [class.menu-collapsed]="sidebar.collapsed$ | async">
      <aside aria-label="Empower navigation"><app-side-overlay-menu></app-side-overlay-menu></aside>
      <main id="workforce-content"><app-dashboard></app-dashboard></main>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .workforce-host-layout { --menu-width: max(220px, 15.32vw); min-height: 100vh; padding-top: 12vh; background: #fafafa; }
    .workforce-host-layout.menu-collapsed { --menu-width: max(64px, 4.8vw); }
    main { min-width: 0; margin-left: var(--menu-width); padding: 24px; transition: margin-left .2s ease; }
    @media (max-width: 760px) {
      main { margin-left: max(64px, 4.8vw); padding: 16px 12px; }
    }
  `],
})
export class WorkforceHostComponent {
  constructor(public sidebar: SidebarService) {}
}
